import { Button } from '@/shared/ui/primitives';
import { UserSelect } from '@/shared/ui/entity-selects';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

interface Props {
  onSubmit: (data: { blockedById: number; blockedUserId: number }) => void;
  isLoading?: boolean;
}

export default function BlockedUsersForm({ onSubmit, isLoading }: Props) {
  const { t } = useTranslation();
  const [blockedById, setBlockedById] = useState<number | null>(null);
  const [blockedUserId, setBlockedUserId] = useState<number | null>(null);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    if (!blockedById || !blockedUserId) return;
    if (blockedById === blockedUserId) return;
    onSubmit({ blockedById, blockedUserId });
  };

  const byError = submitted && !blockedById;
  const targetError = submitted && !blockedUserId;
  const sameError = submitted && blockedById && blockedById === blockedUserId;

  return (
    <form className="ds-form" onSubmit={handleSubmit} style={{ maxWidth: 520 }}>
      <div className="ds-form-item">
        <label className="ds-form-label required">{t('blockedUsers.blockedByLabel')}</label>
        <UserSelect
          value={blockedById}
          onChange={setBlockedById}
          placeholder={t('blockedUsers.blockedByLabel')}
          status={byError ? 'error' : undefined}
        />
        {byError && <div className="ds-form-error">{t('blockedUsers.blockedByLabel')}</div>}
      </div>

      <div className="ds-form-item">
        <label className="ds-form-label required">{t('blockedUsers.blockedUserLabel')}</label>
        <UserSelect
          value={blockedUserId}
          onChange={setBlockedUserId}
          placeholder={t('blockedUsers.blockedUserLabel')}
          status={targetError || sameError ? 'error' : undefined}
        />
        {targetError && <div className="ds-form-error">{t('blockedUsers.blockedUserLabel')}</div>}
        {sameError && <div className="ds-form-error">A user cannot block themselves.</div>}
      </div>

      <div>
        <Button type="primary" htmlType="submit" loading={isLoading}>
          {t('blockedUsers.blockUser')}
        </Button>
      </div>
    </form>
  );
}
